var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"id":"svg--healthcare","xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M18 1l-6 4-6-4-6 5v7l12 10 12-10v-7z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }